// src/components/shared/NoDataFound.jsx
import React from 'react';
import { BarChart3, Clock, Zap } from 'lucide-react'; // Example icons
/**
 * A reusable component to display a placeholder message when no data is available for a section.
 * It features a title, a dynamic icon, and a descriptive message.
 *
 * @param {object} props - The component's props.
 * @param {string} props.title - The main heading to display (e.g., "No Data Recorded").
 * @param {React.ComponentType} [props.icon=Zap] - The Lucide React icon component to display. Defaults to Zap.
 * @param {string} props.message - A descriptive message explaining why there is no data.
 * @param {string} [props.height='h-64'] - Tailwind CSS class for the height of the container (e.g., 'h-64', 'h-full').
 * @returns {React.ReactElement} The rendered "No Data Found" component.
 */
const NoDataFound = ({ title, icon: IconComponent = Zap, message, height = 'h-64' }) => {
    return (
        <div className={`${height} flex flex-col items-center justify-center p-4 text-center bg-[var(--color-surface-background)] border border-[var(--border-color)] transition-all duration-300`}>
            <div className="p-3 mb-4 rounded-full bg-gray-700/70 text-orange-400 animate-pulse-slow">
                <IconComponent className="w-8 h-8" />
            </div>
            <h4 className="text-xl font-semibold text-[var(--primary-text-color)] mb-2">{title}</h4>
            <p className="text-[var(--primary-text-color)] text-sm max-w-sm">{message}</p>
        </div>
    );
};

export default NoDataFound;